import { Canvas } from '@react-three/fiber';
import { Suspense } from 'react';
import RingScene from './RingScene';

const isDebug = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('debug');

/**
 * The Three.js canvas is mounted `fixed` behind all page content.
 * Pointer events are disabled so HTML sections remain interactive.
 * In debug mode (?debug) pointer events are enabled so OrbitControls works.
 */
export default function NeoCanvas() {
    return (
        <div id="three-canvas-root" style={isDebug ? { pointerEvents: 'all' } : undefined}>
            <Canvas
                camera={{ position: [0, 0, 14], fov: 40 }}
                gl={{
                    antialias: true,
                    powerPreference: 'high-performance',
                    alpha: true,
                }}
                shadows
                style={{ width: '100%', height: '100%' }}
            >
                <Suspense fallback={null}>
                    <RingScene />
                </Suspense>
            </Canvas>
        </div>
    );
}
